import { Card, Space, Input, Button, Flex, Statistic, Divider, Col, Row, Avatar, Typography } from 'antd';
import { formatCurrency } from 'utils/number';
import { formatDate } from 'utils/date';
import { PlusOutlined } from '@ant-design/icons';
import CustomerInfoPage from 'components/customer/InfoModal2';
import CustomerInfoEdit from 'components/customer/CustomerInfoEdit';
import _ from 'lodash';

const { Search } = Input;
const { Text } = Typography;

const CustomerListMobile = ({ viewModel }) => {
  const {
    data,
    filter,
    clickPhone,
    showCustomerInfo,
    showAddCustomer,
    setFilterValue,
    onSearch,
    showCustomer,
    refreshList,
    onNavigateOrder,
    onAddCustomer,
    onCloseCustomerInfo,
    onCloseAddCustomer,
  } = viewModel;

  return (
    <Space direction='vertical' size={12} style={{ width: '100%' }}>
      <Card style={{ width: '100%' }}>
        <Space direction='vertical' size={12} style={{ width: '100%' }}>
          <Search
            placeholder='Số điện thoại hoặc tên'
            onSearch={onSearch}
            onChange={(e) => setFilterValue('info', e.target.value)}
            style={{ width: '100%' }}
          />
          <Row gutter={12}>
            <Col span={12}>
              <Statistic title='Khách hàng' value={data.length} size='small' />
            </Col>
            <Col span={12}>
              <Statistic
                title='Tổng xu'
                value={_.sumBy(data, (x) => x.loyalty_point?.current ?? 0)}
                precision={0}
                size='small'
              />
            </Col>
          </Row>
          <Flex justify='flex-end'>
            <Button type='primary' icon={<PlusOutlined />} onClick={onAddCustomer}>
              Thêm
            </Button>
          </Flex>
        </Space>
      </Card>

      <div style={{ paddingBottom: 80 }}>
        <Space direction='vertical' size={8} style={{ width: '100%' }}>
          {data.map((customer) => (
            <Card
              key={customer.id}
              size='small'
              style={{ cursor: 'pointer' }}
              onClick={() => showCustomer(customer.id)}
            >
              <Space direction='vertical' size={4} style={{ width: '100%' }}>
                <Flex justify='space-between' align='center'>
                  <Space size={8}>
                    <Avatar size={32}>{customer.phone?.charAt(0)}</Avatar>
                    <Space direction='vertical' size={0}>
                      <Text strong>{customer.phone}</Text>
                      <Text type='secondary' style={{ fontSize: 12 }}>
                        {customer.full_name}
                      </Text>
                    </Space>
                  </Space>
                  <Text type='success' strong>
                    {formatCurrency(customer.loyalty_point?.current)}
                  </Text>
                </Flex>

                <Divider style={{ margin: '4px 0' }} />

                <Row gutter={12}>
                  <Col span={12}>
                    <Text type='secondary' style={{ fontSize: 11 }}>
                      Doanh thu
                    </Text>
                    <div>
                      <Text strong style={{ fontSize: 13 }}>
                        {formatCurrency(customer.stats?.total_spend)}
                      </Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <Text type='secondary' style={{ fontSize: 11 }}>
                      Gần đây
                    </Text>
                    <div>
                      <Text strong style={{ fontSize: 13 }}>
                        {formatCurrency(customer.stats?.recent_spend)}
                      </Text>
                    </div>
                  </Col>
                </Row>

                {customer.stats?.last_order?.id && (
                  <>
                    <Divider style={{ margin: '4px 0' }} />
                    <Flex justify='space-between' align='center'>
                      <Space direction='vertical' size={0}>
                        <Text type='secondary' style={{ fontSize: 11 }}>
                          Đơn gần đây
                        </Text>
                        <Text
                          strong
                          style={{ fontSize: 13, cursor: 'pointer', color: '#1890ff' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            onNavigateOrder(customer.stats?.last_order?.id);
                          }}
                        >
                          {customer.stats?.last_order?.id}
                        </Text>
                      </Space>
                      <Space direction='vertical' size={0} align='end'>
                        <Text strong style={{ fontSize: 13 }}>
                          {formatCurrency(customer.stats?.last_order.total_amount)}
                        </Text>
                        <Text type='secondary' style={{ fontSize: 11 }}>
                          {formatDate(customer.stats?.last_order.create_on)}
                        </Text>
                      </Space>
                    </Flex>
                  </>
                )}
              </Space>
            </Card>
          ))}
        </Space>
      </div>

      <CustomerInfoPage
        id={clickPhone}
        open={showCustomerInfo}
        onClose={onCloseCustomerInfo}
        onSave={refreshList}
      />
      <CustomerInfoEdit
        open={showAddCustomer}
        onClose={onCloseAddCustomer}
        onSave={refreshList}
      />
    </Space>
  );
};

export default CustomerListMobile;
